<template>
  <div class="col-md-12 p-0 mx-auto" style="border: none!important;">
    <h6>آگهی های دسته انتخابی</h6>
    <p class="text-muted">توجه! :برای انتخاب آگهی موردنظر روی هر سطر کلیک کنید.</p>
    <div class="d-flex px-0 justify-content-between">
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="importAds" fab icon v-bind="attrs" v-on="on"><i
                class="fa fa-download text-info"></i></v-btn>
          </template>
          <span>بارگیری آگهی های املاک</span>
        </v-tooltip>
      </div>
      <v-menu
          top
          :close-on-click="true"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
          >
            فیلترها
          </v-btn>
        </template>

        <v-list>
          <v-list-item
              v-for="(item, index) in selectList"
              :key="index"
              @click="filterSelections(item.value)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </div>

    <v-data-table
        v-model="selectedAds"
        :headers="headers"
        :loading="loading"
        :items="advertiseList"
        :item-key="advertiseList.manage_token"
        :search="search"
        :items-per-page="5"
        @click:row="rowClicked"
        align="center"
        :footer-props="{'items-per-page-text':'تعداد  ردیف  در هر صفحه',
                'items-per-page-options':[5,10, 30, 50, 100, -1],

                }"
        class="elevation-1 table-bordered table-hover table-striped p-4"
    >
      <template v-slot:top>
        <div class="row mx-auto">
          <v-btn class="my-auto purple lighten-4" @click="selectAll">انتخاب همه</v-btn>

          <v-text-field
              v-model="search"
              label="جستجو"
              append-icon="mdi-magnify"
              dense
              class="mx-4 my-3 mt-4"
          ></v-text-field>
        </div>
      </template>
      <template v-slot:item="{ item }">
        <tr data-item="advertise" :class="selectedAds.indexOf(item.manage_token)> -1?'purple lighten-4':''"
            @click="rowClicked(item)">
          <td>{{ item.title }}</td>
          <td>{{ item.data }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.phone != null ? item.phone + '  - ' + item.nickname : 'نیاز به بارگیری آگهی' }}</td>
        </tr>
      </template>
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} از {{ items.itemsLength }}
      </template>

    </v-data-table>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {Bus, dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import NumberSelector from "@/view/pages/ads/numberSelector";

export default {
  name: "adsLIst",
  components: {NumberSelector, CreateDefault, TitleRibbon, button, dataTableProps, createTarefe},
  props: {
    category: {
      default: ''
    },
    city: {
      default: ''
    },
    neighborhood: {
      default: ''
    },
    all: {
      default: false,
    },
    ladder: {
      default: false,
    },
    marketNumber: {
      dafault: ''
    },
    marketNumberId: {
      default: ''
    },
    list: {
      default: [],
    }
  },
  data() {
    return {
      search: '',
      loading: false,
      translates: [],
      ownAds: [],
      selectedAds: [],
      headers: [
        {text: 'عنوان', value: 'title'},
        {text: 'زمان انتشار', value: 'data'},
        {text: 'تعداد دفعات نردبان شده', value: 'price'},
        {text: 'شماره ', value: 'phone'},
      ],
      selectList: [
        {title: 'انتخاب همه از بالا', value: 'top'},
        {title: 'انتخاب همه از پایین', value: 'bottom'},
        {title: 'انتخاب همه تصادفی', value: 'shuffle'},
        {title: 'انتخاب نردبان نشده ها', value: 'not gradual'},
        {title: 'انتخاب عدم نردبان بیش از 1 روز', value: '1more'},
        {title: 'انتخاب عدم نردبان بیش از 3 روز', value: '3more'},
        {title: ' انتخاب عدم نردبان بیش از 1 هفته', value: '7more'},
      ],
      remainingData: [],
      CurrentTab: ''
    }
  },
  methods: {
    getRemainingData() {
      this.loading = true
      if (this.marketNumberId.length > 0 || this.marketNumberId !== '')
        $.ajax({
          url: `${url}/divar/agency/remaining/${this.marketNumberId}`,
          method: "GET",
          fn: this.getRemainingData,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token
          },
          success: (res) => {
            this.remainingData = res.data;
            this.ownAds = res.data
            this.loading = false
          },
          error: function () {
            this.loading = false
          }
        })
    },
    importAds() {
      $.ajax({
        url: `${url}/divar/agency/import/${this.marketNumberId}`,
        method: "POST",
        fn: this.importAds,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        msg: false,
        success: (res) => {
          this.$nextTick(function () {
            this.$modal.success('بارگیری موفقیت آمیز!', 'بارگیری اگهی های شما موفقیت آمیز بود.')
          })
        }
      })
    },
    rowClicked(row) {
      this.toggleSelection(row.manage_token);
    },
    toggleSelection(keyID) {
      if (this.selectedAds.includes(keyID)) {
        this.selectedAds = this.selectedAds.filter(
            selectedKeyID => selectedKeyID !== keyID
        );
      } else {
        this.selectedAds.push(keyID)
      }
    },
    filterOnlyCapsText(value, search, item) {
      return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().indexOf(search) !== -1
    },
    async selectAll() {
      for (let item of this.advertiseList) {
        this.toggleSelection(item.manage_token);
        await new Promise(resolve => setTimeout(resolve, 25))
      }
    },
    async filterSelections(position) {
      switch (position) {
        case 'top':
          this.selectedAds = []
          this.selectAll();
          break;
        case 'bottom':
          this.selectedAds = []
          this.selectAll();
          this.selectedAds.reverse();
          break;
        case 'shuffle':
          this.selectedAds = []
          this.selectAll()
          if (this.selectedAds.length < this.ownAds.length)
            setTimeout(() => {
              this.selectedAds.sort(() => Math.random() - 0.5);
            }, 2500)
          break;
        case '1more':
          this.selectedAds = []
          const list = this.ownAds.data.filter(x => x.data.includes('روز') || x.data.includes('هفته'));

          for (const item of list) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }
          break;
        case '3more':
          this.selectedAds = []
          const lists = this.ownAds.data.filter(x => (x.data.includes('روز') || x.data.includes('هفته')) && (!x.data.includes('دیروز') && !x.data.includes('پریروز')));

          for (const item of lists) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }

          break;
        case 'not gradual':
          this.selectedAds = []
          const list8 = this.ownAds.data.filter(x => x.data.includes('نردبان نشده'));

          for (const item of list8) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }
          break;
        case '7more':
          this.selectedAds = []
          const list7 = this.ownAds.data.map(x => {
            return {
              ...x,
              data: this.english(x.data)
            }
          }).filter(x => (x.data.includes('روز') || x.data.includes('هفته')) && (!x.data.includes('دیروز') && !x.data.includes('پریروز')))
              .filter(x => x.data.includes('هفته') || x.data.match(/\d+/)?.[0] > 7);

          for (const item of list7) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }

          break;

      }
    }

  },
  watch: {
    selectedAds: {
      handler: function () {
        Bus.$emit('selectedAds', this.selectedAds)
      },
      deep: true
    },
    all: {
      handler: function () {
        this.ownAds = [];
        this.getMyAds()
      },
      deep: true
    },
    marketNumberId: function () {
      if (this.marketNumberId !== '' || this.marketNumberId.length > 0) {
        this.ownAds = [];
        this.getRemainingData();
      }
    },
    remainingData: {
      handler: function (val) {
        Bus.$emit('maxCountOfLadder', this.remainingData);
      },
      deep: true
    },

  },
  computed: {
    advertiseList() {
      let data = this.ownAds?.data ?? this.ownAds;
      let uniq = {};

      data.forEach(item => {
        uniq[item.manage_token] = item;
      })

      return Object.values(uniq);
    }
  },
  mounted() {
    if (this.list.length <= 0)
      this.getRemainingData();
    else {
      this.remainingData = this.list;
      this.ownAds = this.list;
    }
  }
}
</script>

<style>
table thead.v-data-table-header th {
  font-size: 15px !important;
  padding: 13px !important;
  text-align: right !important;
}

table thead.v-data-table th {
  font-size: 15px !important;
  padding: 13px !important;
  text-align: right !important;
}

#list-item-294-5 .v-list-item__content .v-list-item__title {
  display: none;
}

#list-item-294-5 .v-list-item__content:after {
  content: 'همه';
}
</style>